export const ALL_PRICES_VALUE = "0-99999"

export function bandValuesToUncheck(changedValue, selectedValues) {
  if (changedValue === ALL_PRICES_VALUE) return selectedValues.filter((value) => value !== ALL_PRICES_VALUE)

  return selectedValues.includes(ALL_PRICES_VALUE) ? [ALL_PRICES_VALUE] : []
}
